
<!--<footer class="footer">
  <div class="container" style="z-index: 10">
    <div class="copyright float-left">
      &copy;{{year}} FIAP Portal.
    </div>
    <div class="copyright float-right">
      All right reserved.Powered by  <a href="https://www.upperlink.ng" target="_blank">Upperlink Limited</a>
    </div>
  </div>
</footer>-->
<br>
<mat-divider></mat-divider>
<!-- Footer -->

<footer class="footer pt-0">
  <div fxLayout="row" fxLayout.lt-sm="column" fxLayout.lt-md="column" fxLayoutAlign="space-around center"
       fxLayoutGap="10px" style="margin-top: 30px; margin-bottom: 0">
    <div fxFlex="60" class="col-lg-6">
      <div class="copyright text-center  text-lg-left  text-muted"  style="color: black !important;">
        &copy;{{year}}
        <a href="https://tech.upperlink.ng/paychoic/" class="font-weight-bold ml-1" target="_blank">
          FIAP Portal.
        </a>
      </div>
    </div>
    <div fxFlex="40" class="col-lg-6" style="color: black;">
      <ul class="nav nav-footer justify-content-center justify-content-lg-end">
        <li class="nav-item">
          <a href="https://www.upperlink.ng" class="nav-link" target="_blank">Upperlink Limited</a>
        </li>
        <li class="nav-item">
          <a href="https://tech.upperlink.ng/" class="nav-link" target="_blank">Upperlink
            Developers</a>
        </li>
      </ul>
    </div>
  </div>
</footer>

